import Splide from '@splidejs/splide';

const hero = document.querySelector('.hero');
const heroSlider = hero.querySelector('.hero__slider');
const learnMoreBtn = hero.querySelector('button.hero__learn-more');

// hero slider
if( heroSlider ) {
    var splide = new Splide( '.hero__slider' , {
        type: 'fade',
        rewind: true,
        speed: 2500,
        interval: 3500,
        autoplay: true,
        arrows: false,
        pagination: false,
        perPage: 1,
        perMove: 1
    });
    splide.mount();
}

// go to next section
if(learnMoreBtn) {
    learnMoreBtn.addEventListener('click', (e)=> {
        hero.nextElementSibling.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'center'
        });
    });
}